interface IllustrationImageProps {
  src: string;
}

const IllustrationImage = ({ src }: IllustrationImageProps) => (
  <img
    src={src}
    alt=""
    width={512}
    height={512}
    draggable={false}
    className="h-full w-full object-contain"
  />
);

export const OwnContentIllustration = () => (
  <IllustrationImage src="/images/onboarding/objective-own-content.png" />
);

export const ClientWorkIllustration = () => (
  <IllustrationImage src="/images/onboarding/objective-client-content.png" />
);

export const ClippingChannelIllustration = () => (
  <IllustrationImage src="/images/onboarding/objective-clipping-channels.png" />
);
